import { z } from "@/zod";

export const VISUALIZATION_HORIZONTAL = "horizontal";
export const VISUALIZATION_VERTICAL = "vertical";

export const VISUALIZATION = [
  VISUALIZATION_HORIZONTAL,
  VISUALIZATION_VERTICAL,
] as const;

export default z.enum(VISUALIZATION);
